function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenceAvailableMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.36,16.81c-2.71,0-4.91-2.5-4.91-5.51A5,5,0,0,1,14.24,6h.15a5,5,0,0,1,4.85,5.17h0v.13C19.24,14.36,17.07,16.81,14.36,16.81Z",
    style: {
      fill: "#6bae44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.85,16V26H26.5V16Z",
    style: {
      fill: "#9767b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.74,18.32a5.57,5.57,0,0,0-.92.83,3.82,3.82,0,0,1-2.45.83h-.76a3.9,3.9,0,0,1-2.5-.83,6,6,0,0,0-1.18-1,2,2,0,0,0-2.37.39,18.49,18.49,0,0,0-2.5,3.8l-.35.88c-.16.36-.34,1-.09,1.33a2.08,2.08,0,0,0,1.51.53H18.76Z",
    style: {
      fill: "#6bae44"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.96,
    y: 23.21,
    width: 1.11,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.96,
    y: 21.55,
    width: 1.11,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.62,
    y: 23.21,
    width: 1.11,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.62,
    y: 21.55,
    width: 1.11,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.28,
    y: 23.21,
    width: 1.11,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.28,
    y: 21.55,
    width: 1.11,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.96,
    y: 17.13,
    width: 4.42,
    height: 3.32,
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceAvailableMobile);
export default __webpack_public_path__ + "static/media/presence-available-mobile.5b27de95.svg";
export { ForwardRef as ReactComponent };